import { combineReducers } from '@reduxjs/toolkit';
import userSlice from '../actions/userSlice';
import notificationsSlice from '../actions/notificationsSlice';
import configurationSlice from '../actions/configurationSlice';

const rootReducer = combineReducers({
  user: userSlice,
  notifications: notificationsSlice,
  configuration: configurationSlice
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
